import { create } from 'zustand';
import { adminEmailRequestsApi } from '@api/api-config.ts';
import { AdminEmailRequestResponse } from '@api/generated/portal-be-admin';

export interface EmailRequestFilters {
  search?: string;
  status?: string;
  notificationType?: string;
  page: number;
  size: number;
}

interface PaginationInfo {
  page: number;
  size: number;
  total: number;
  totalPages: number;
  hasPrev: boolean;
  hasNext: boolean;
}

interface AdminEmailRequestStoreState {
  loading: boolean;
  error: string | null;
  data: AdminEmailRequestResponse[] | null;
  pagination: PaginationInfo | null;
  loadEmailRequests: (filters: EmailRequestFilters) => Promise<void>;
}

export const useAdminEmailRequestStore = create<AdminEmailRequestStoreState>(set => ({
  loading: false,
  error: null,
  data: null,
  pagination: null,

  loadEmailRequests: async (filters: EmailRequestFilters) => {
    try {
      set({ loading: true, error: null });
      const response = await adminEmailRequestsApi.getAdminEmailRequests({
        page: filters.page,
        size: filters.size,
        search: filters.search,
        status: filters.status as any,
        notificationType: filters.notificationType as any,
      });
      const result = response.data;
      set({
        loading: false,
        error: null,
        data: result.items || [],
        pagination: {
          page: result.page,
          size: result.size,
          total: result.total,
          totalPages: result.totalPages,
          hasPrev: result.hasPrev,
          hasNext: result.hasNext,
        },
      });
    } catch (error) {
      set({
        loading: false,
        error: error instanceof Error ? error.message : 'Chyba pri nacitani email requestu',
      });
    }
  },
}));
